import type { BlobLike } from "@pdfking/compatibility"
import type { AsyncSequence, Bytes } from "@pdfking/tfunc"

// Input parameters for PDFReader

export type PDFReaderOptions = {
  stream: AsyncSequence<BlobLike>
  size: Bytes
  type: string
  password?: string
}
